/* eslint eqeqeq: off */
import React, {Component} from "react";
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise';
import Group from "../../../Components/Group";
import './index.css';
import Grid, {GridButton, GridControls, gridDateTime, GridState, GridStates} from "../../../Components/Grid";
import Modal, {ModalAction, ModalContent, ModalControls} from "../../../Components/Modal";
import Resource from "../../../Resource";
import Prompt, {PromptControl} from "../../../Components/Prompt";
import Hospital from "../../../Server/Hospital";
import PropTypes from "prop-types";
import Button from "../../../Components/Control/Button";
import Notif from "../../../Components/Notif";
import {connect} from "react-redux";
import ModalNormRequest from "../ModalNormRequest";
import ModalEmerRequest from "../ModalEmerRequest";
import ModalHospitalAcceptRequest from '../ModalHospitalAcceptRequest';
import ModalOrgEmerRequest from '../ModalOrgEmerRequest';
import ModalWashRequest from '../ModalWashRequest';
import ModalIrradiateRequest from '../ModalIrradiateRequest';
import Perms from '../../../Perms';
import Org from "../../../Server/Org";
import ModalOrgNormRequest from "../ModalOrgNormRequest";

class ModalAwaitingRequests extends Component {
    constructor(props) {
        super(props);
        props.refer.current = this;

        this.Perms = {
            'false1': { // Norm
                VIEW: Perms().BLOOD_BANK_NORM_REQUESTS.AWAITING.VIEW,
                CONFIRM: Perms().BLOOD_BANK_NORM_REQUESTS.AWAITING.CONFIRM,
                REJECT: Perms().BLOOD_BANK_NORM_REQUESTS.AWAITING.REJECT,
                SET_BLOOD_GROUP: Perms().BLOOD_BANK_NORM_REQUESTS.AWAITING.SET_BLOOD_GROUP
            },
            'false2': { // Emer
                VIEW: Perms().BLOOD_BANK_EMER_REQUESTS.AWAITING.VIEW,
                CONFIRM: Perms().BLOOD_BANK_EMER_REQUESTS.AWAITING.CONFIRM,
                REJECT: Perms().BLOOD_BANK_EMER_REQUESTS.AWAITING.REJECT,
                SET_BLOOD_GROUP: Perms().BLOOD_BANK_EMER_REQUESTS.AWAITING.SET_BLOOD_GROUP
            },
            'false3': { // Wash
                VIEW: Perms().BLOOD_BANK_WASH_REQUESTS.AWAITING.VIEW,
                CONFIRM: Perms().BLOOD_BANK_WASH_REQUESTS.AWAITING.CONFIRM,
                REJECT: Perms().BLOOD_BANK_WASH_REQUESTS.AWAITING.REJECT
            },
            'false4': { // Irradiate
                VIEW: Perms().BLOOD_BANK_IRRADIATE_REQUESTS.AWAITING.VIEW,
                CONFIRM: Perms().BLOOD_BANK_IRRADIATE_REQUESTS.AWAITING.CONFIRM,
                REJECT: Perms().BLOOD_BANK_IRRADIATE_REQUESTS.AWAITING.REJECT
            },
            'false5': { // Org Emer
                VIEW: Perms().BLOOD_BANK_ORG_EMER_REQUESTS.AWAITING.VIEW,
                CONFIRM: Perms().BLOOD_BANK_ORG_EMER_REQUESTS.AWAITING.CONFIRM,
                REJECT: Perms().BLOOD_BANK_ORG_EMER_REQUESTS.AWAITING.REJECT
            },
            'true1': { // Org Norm
                VIEW: Perms().ORG_NORM_REQUESTS.AWAITING.VIEW,
                CONFIRM: Perms().ORG_NORM_REQUESTS.AWAITING.CONFIRM,
                REJECT: Perms().ORG_NORM_REQUESTS.AWAITING.REJECT
            },
            'true2': { // Org Emer
                VIEW: Perms().ORG_EMER_REQUESTS.AWAITING.VIEW,
                CONFIRM: Perms().ORG_EMER_REQUESTS.AWAITING.CONFIRM,
                REJECT: Perms().ORG_EMER_REQUESTS.AWAITING.REJECT
            },
            'true3': { // Org Wash
                VIEW: Perms().ORG_WASH_REQUESTS.AWAITING.VIEW,
                CONFIRM: Perms().ORG_WASH_REQUESTS.AWAITING.CONFIRM,
                REJECT: Perms().ORG_WASH_REQUESTS.AWAITING.REJECT
            },
            'true4': { // Org Irradiate
                VIEW: Perms().ORG_IRRADIATE_REQUESTS.AWAITING.VIEW,
                CONFIRM: Perms().ORG_IRRADIATE_REQUESTS.AWAITING.CONFIRM,
                REJECT: Perms().ORG_IRRADIATE_REQUESTS.AWAITING.REJECT
            }
        };

        this.state = {
            grid: {
                defaultColDef: {
                    floatingFilter: false
                },
                columnDefs: [],// تو تابع open تعریف میشه چون دو تا حالت داریم
                frameworkComponents: {
                    state: row => {
                        return <GridStates>
                            {row.data.statusId === 20 && <GridState theme={'yellow'}>{row.data.statusStr}</GridState>}
                            {row.data.statusId === 24 && <GridState theme={'yellow'}>{row.data.statusStr}</GridState>}
                            {row.data.formTypeId === 1 && <GridState theme={'green'}>عادی</GridState>}
                            {row.data.formTypeId === 2 && <GridState theme={'red'}>اورژانسی</GridState>}
                            {row.data.formTypeId === 3 && <GridState theme={'red'}>خون شسته</GridState>}
                            {row.data.formTypeId === 4 && <GridState theme={'red'}>خون اشعه‌دیده</GridState>}
                            {row.data.formTypeId === 5 && <GridState theme={'red'}>اورژانسی از سازمان</GridState>}
                            {row.data.requestPurposeId == 1 && <GridState theme={'blue'}>رزرو</GridState>}
                            {row.data.requestPurposeId == 2 && <GridState theme={'blue'}>تزریق</GridState>}
                        </GridStates>;
                    },
                    control: row => {
                        return <GridControls>
                            <GridButton type={"button"} theme={'view'} title={'مشاهده'} onClick={this.view.bind(this, row.data)}/>
                            {this.Perms[`${Boolean(row.data.hospitalRequestId)}${row.data.formTypeId}`].CONFIRM && (row.data.statusId === 24 || row.data.statusId === 61) && <GridButton type={"button"} theme={'add'} icon={Resource.IMAGE.PACK.CHECK.WHITE} title={'تایید'} onClick={this.confirm.bind(this, row.data)}/>}
                            {/*این دکمه از اینجا به کارتابل اصلی منتقل شده ولی از اینجا پاک نکردم که بعدا شاید دوباره برگشتیم*/}
                            {this.Perms[`${Boolean(row.data.hospitalRequestId)}${row.data.formTypeId}`].SET_BLOOD_GROUP && row.data.statusId === 20 && <GridButton type={"button"} theme={'accept'} title={'تعیین'} onClick={this.accept.bind(this, row.data)}/>}
                            {this.Perms[`${Boolean(row.data.hospitalRequestId)}${row.data.formTypeId}`].REJECT && <GridButton type={"button"} theme={'delete'} title={'حذف'} onClick={this.reject.bind(this, row.data)}/>}
                        </GridControls>;
                    }
                },
                getContextMenuItems: params => {
                    if (params.node)
                        return [{
                            name: 'مشاهده درخواست',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.EYE.BLACK}" alt="">`,
                            action: this.view.bind(this, params.node.data)
                        }, {
                            name: 'تایید درخواست',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.CHECK.BLACK}" alt="">`,
                            action: this.confirm.bind(this, params.node.data),
                            disabled: !this.Perms[`${Boolean(params.node.data.hospitalRequestId)}${params.node.data.formTypeId}`].CONFIRM
                        }, {
                            name: 'تعیین گروه خونی',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.CHECK.BLACK}" alt="">`,
                            action: this.accept.bind(this, params.node.data),
                            disabled: !this.Perms[`${Boolean(params.node.data.hospitalRequestId)}${params.node.data.formTypeId}`].SET_BLOOD_GROUP
                        }, {
                            name: 'حذف درخواست',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.CANCEL.BLACK}" alt="">`,
                            action: this.reject.bind(this, params.node.data),
                            disabled: !this.Perms[`${Boolean(params.node.data.hospitalRequestId)}${params.node.data.formTypeId}`].REJECT
                        },
                            'separator',
                            ...params.defaultItems];
                },
                help: _ => {
                    return <div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>وضعیت‌ها:</h3>
                                <p><GridState theme={'yellow'}>در انتظار تحویل درخواست</GridState> درخواست رسیده از بخش در انتظار تحویل می باشد. (بعد از تحویل درخواست بخش اجازه ویرایش درخواست را ندارد.)</p>
                                <p><GridState theme={'yellow'}>در انتظار تعیین گروه خونی</GridState> درخواست رسیده از بخش در انتظار تعیین گروه خونی نمونه بیمار می باشد. (بعد از تعیین گروه خونی نمونه خون بیمار درخواست از لیست انتظار خارج شده و به ککارتابل اصلی منتقل می شود.)</p>
                                <p><GridState theme={'green'}>عادی</GridState> درخواست فرآورده از نوع عادی می باشد.</p>
                                <p><GridState theme={'red'}>اورژانسی</GridState> درخواست فرآورده از نوع اورژانسی می باشد.</p>
                                <p><GridState theme={'red'}>خون شسته</GridState> درخواست فرآورده از نوع خون شسته می باشد.</p>
                                <p><GridState theme={'red'}>خون اشعه‌دیده</GridState> درخواست فرآورده از نوع خون اشعه دیده می باشد.</p>
                                <p><GridState theme={'red'}>اورژانسی از سازمان</GridState> درخواست فرآورده از سازمان با وضعیت اورژانسی می باشد.</p>
                            </div>
                        </div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>عملیات:</h3>
                                <p><GridButton theme={'view'} title={'مشاهده'}/> در صورت نیاز به مشاهده درخواست می توانید از این طریق اقدام کنید.</p>
                                <p><GridButton theme={'blue'} title={'تایید'} icon={Resource.IMAGE.PACK.CHECK.WHITE}/> جهت صلب دسترسی بخش از ویرایش درخواست بایستی بعد از مشاهده، درخواست تایید شود.</p>
                                <p><GridButton theme={'accept'} title={'تعیین'}/> پس از تعیین گروه خونی از این طریق نسبت به ثبت آن اقدام نمایید تا درخواست به کارتابل اصلی منتقل شود.</p>
                                <p><GridButton theme={'delete'} title={'حذف'}/> در صورتی نیاز به حذف درخواست می توانید از این طریق اقدام نمایید.</p>
                            </div>
                        </div>
                    </div>;
                }
            },
            rowData: [],
            selectedRows: [],
            gridContext: null,
            updated: false // checks if modal has been updated so the parent need reload or not
        };

        this.ref = {
            grid: React.createRef(),
            modal: React.createRef(),
            prompt: React.createRef(),
            modalHospitalAcceptRequest: React.createRef(),
            modalNormRequest: React.createRef(),
            modalEmerRequest: React.createRef(),
            modalWashRequest: React.createRef(),
            modalOrgEmerRequest: React.createRef(),
            modalOrgNormRequest: React.createRef()
        };
    }

    static defaultProps = {
        refer: {current: null},
        onClose: _ => null,
        onSuccess: _ => null
    };

    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func,
        onSuccess: PropTypes.func
    };

    componentDidMount() {

    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.state.grid !== nextState.grid ||
            this.state.rowData !== nextState.rowData;
    }

    render() {
        return <React.Fragment>
            <Modal ref={this.ref.modal}
                   name={'ModalAwaitingRequests'}
                   size={'large'}
                   title={'درخواست‌های در انتظار تایید'}
                   style={{height: 'calc(100vh - 60)'}}
                   onClose={this.props.onClose}>
                <ModalContent>
                    <Group className={'ModalAwaitingRequests-group fb-20'}>
                        <Grid refer={this.ref.grid} id={'awaitingRequests'} {...this.state.grid} rowData={this.state.rowData} onGridReady={this.gridReadyHandler.bind(this)} onSelectionChanged={this.gridSelectionHandler.bind(this)}/>
                    </Group>
                </ModalContent>
                <ModalControls>
                    <Button refer={this.ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
                </ModalControls>
            </Modal>
            <Prompt ref={this.ref.prompt}/>
            <ModalNormRequest refer={this.ref.modalNormRequest}/>
            <ModalEmerRequest refer={this.ref.modalEmerRequest}/>
            <ModalWashRequest refer={this.ref.modalWashRequest}/>
            <ModalIrradiateRequest refer={this.ref.modalIrradiateRequest}/>
            <ModalOrgEmerRequest refer={this.ref.modalOrgEmerRequest}/>
            <ModalOrgNormRequest refer={this.ref.modalOrgNormRequest}/>
            <ModalHospitalAcceptRequest refer={this.ref.modalHospitalAcceptRequest} onSuccess={this.modalSuccessHandler.bind(this)}/>
        </React.Fragment>;
    }

    updateGrid(closeIfEmpty = false) {
        this.ref.grid.current.loading();

        switch (this.checkWorkArea()) {
            case'HOSPITAL':
                Hospital.requestList()
                    .then(list => {
                        this.ref.grid.current.loading(false);

                        const filteredList = (list || []).filter(this.filterMethod.bind(this));
                        if (closeIfEmpty && !filteredList.length) {
                            this.close();
                        }

                        this.setState({rowData: filteredList});
                    });
                break;
            case 'ORG':
                Org.requestList()
                    .then(list => {
                        this.ref.grid.current.loading(false);

                        const filteredList = (list || []).filter(this.filterMethod.bind(this));
                        if (closeIfEmpty && !filteredList.length) {
                            this.close();
                        }

                        this.setState({rowData: filteredList});
                    });
                break;
            default:
                this.close();
                break;
        }
    }

    gridReadyHandler(params) {
        this.updateGrid();

        this.setState({gridContext: params});
    }

    gridSelectionHandler(rows) {
        this.setState({selectedRows: rows});
    }

    accept(row) {
        this.ref.modalHospitalAcceptRequest.current.open(row, 'ACCEPT');
    }

    checkWorkArea(action = this.state.action) {
        switch (action) {
            case Resource.HASH.AWAITING_HOSPITAL_NORM_EMER_REQUESTS:
            case Resource.HASH.AWAITING_HOSPITAL_NORM_REQUESTS:
            case Resource.HASH.AWAITING_HOSPITAL_EMER_REQUESTS:
            case Resource.HASH.AWAITING_HOSPITAL_WASH_REQUESTS:
            case Resource.HASH.AWAITING_HOSPITAL_IRRADIATE_REQUESTS:
            case Resource.HASH.AWAITING_HOSPITAL_ORG_EMER_REQUESTS:
                return 'HOSPITAL';
            case Resource.HASH.AWAITING_ORG_NORM_REQUESTS:
            case Resource.HASH.AWAITING_ORG_EMER_REQUESTS:
            case Resource.HASH.AWAITING_ORG_WASH_REQUESTS:
            case Resource.HASH.AWAITING_ORG_IRRADIATE_REQUESTS:
                return 'ORG';
            default:
                return null;
        }
    }

    close() {
        this.ref.modal.current.close();

        if (this.state.updated)
            this.props.onSuccess();

        this.props.onClose();
    }

    confirm(row, props = {loading: _ => null}) {
        this.ref.prompt.current.open({
            title: 'اخطار',
            description: 'آیا می خواهید درخواست مورد نظر را تایید کنید؟',
            buttons: PromptControl.OK_CANCEL,
            onClose: button => {
                if (button.id === PromptControl.OK) {
                    props.loading();

                    if (this.checkWorkArea(this.state.action) === 'HOSPITAL') {
                        Hospital.receiveRequest({
                            sectionRequestId: row?.sectionRequestId
                        }).then(_ => {
                            this.setState({updated: true});
                            this.updateGrid(true);
                            new Notif(Resource.STRING.FETCH.SUBMIT_SUCCESSFUL).show();
                            props.loading(false);
                        }).catch(message => {
                            new Notif({message, theme: 'error'}).show();
                            props.loading(false);
                        });
                    } else if (this.checkWorkArea(this.state.action) === 'ORG') {
                        Org.receiveRequest({
                            hospitalRequestId: row?.hospitalRequestId
                        }).then(_ => {
                            this.setState({updated: true});
                            this.updateGrid(true);
                            new Notif(Resource.STRING.FETCH.SUBMIT_SUCCESSFUL).show();
                            props.loading(false);
                        }).catch(message => {
                            new Notif({message, theme: 'error'}).show();
                            props.loading(false);
                        });
                    }
                }
            }
        });
    }

    filterMethod(item) {
        switch (this.state.action) {
            case Resource.HASH.AWAITING_HOSPITAL_NORM_EMER_REQUESTS:
                return item.formTypeId == 1 || item.formTypeId == 2;
            case Resource.HASH.AWAITING_ORG_NORM_REQUESTS:
            case Resource.HASH.AWAITING_HOSPITAL_NORM_REQUESTS:
                return item.formTypeId == 1;
            case Resource.HASH.AWAITING_ORG_EMER_REQUESTS:
            case Resource.HASH.AWAITING_HOSPITAL_EMER_REQUESTS:
                return item.formTypeId == 2;
            case Resource.HASH.AWAITING_ORG_WASH_REQUESTS:
            case Resource.HASH.AWAITING_HOSPITAL_WASH_REQUESTS:
                return item.formTypeId == 3;
            case Resource.HASH.AWAITING_ORG_IRRADIATE_REQUESTS:
            case Resource.HASH.AWAITING_HOSPITAL_IRRADIATE_REQUESTS:
                return item.formTypeId == 4;
            case Resource.HASH.AWAITING_HOSPITAL_ORG_EMER_REQUESTS:
                return item.formTypeId == 5;
            default:
                return true;
        }
    }

    getFilteredRows(list = []) {
        if (list)
            switch (this.state.action) {
                case Resource.HASH.AWAITING_HOSPITAL_NORM_EMER_REQUESTS:
                    return list.filter(item => item.id == 1 || item.id == 2);
                case Resource.HASH.AWAITING_ORG_NORM_REQUESTS:
                case Resource.HASH.AWAITING_HOSPITAL_NORM_REQUESTS:
                    return list.filter(item => item.id == 1);
                case Resource.HASH.AWAITING_ORG_EMER_REQUESTS:
                case Resource.HASH.AWAITING_HOSPITAL_EMER_REQUESTS:
                    return list.filter(item => item.id == 2);
                case Resource.HASH.AWAITING_ORG_WASH_REQUESTS:
                case Resource.HASH.AWAITING_HOSPITAL_WASH_REQUESTS:
                    return list.filter(item => item.id == 3);
                case Resource.HASH.AWAITING_ORG_IRRADIATE_REQUESTS:
                case Resource.HASH.AWAITING_HOSPITAL_IRRADIATE_REQUESTS:
                    return list.filter(item => item.id == 4);
                case Resource.HASH.AWAITING_HOSPITAL_ORG_EMER_REQUESTS:
                    return list.filter(item => item.id == 5);
                default:
            }
        return list;
    }

    modalSuccessHandler() {
        this.setState({updated: true});

        this.updateGrid(true);
    }

    open(data, action) {
        const grid = {...this.state.grid};

        this.ref.modal.current.open();

        switch (this.checkWorkArea(action)) {
            case 'HOSPITAL':
                grid.columnDefs = [{
                    field: 'fileCode',
                    headerName: 'شماره پرونده',
                    headerTooltip: 'شماره پرونده',
                    checkboxSelection: true,
                    headerCheckboxSelection: true,
                    filter: 'agTextColumnFilter'
                }, {
                    field: 'fullName',
                    headerName: 'نام',
                    headerTooltip: 'نام'
                }, {
                    field: 'nationalCode',
                    headerName: 'کد ملی',
                    headerTooltip: 'کد ملی'
                }, {
                    field: 'sectionStr',
                    headerName: 'نام بخش',
                    headerTooltip: 'نام بخش'
                }, {
                    field: 'createDateTime',
                    headerName: 'زمان درخواست',
                    headerTooltip: 'زمان درخواست',
                    valueGetter: gridDateTime.bind(this, 'date'),
                    cellRenderer: gridDateTime
                }, {
                    field: 'state',
                    headerName: 'وضعیت',
                    headerTooltip: 'وضعیت',
                    pinned: this.props.gridDefaultSettings.pinStatusColumn,
                    sortable: false,
                    enableRowGroup: false,
                    cellRenderer: 'state',
                    valueGetter: row => {
                        const filters = [row.data.statusStr];

                        switch (row.data.formTypeId) {
                            case 1:
                                filters.push('عادی');
                                break;
                            case 2:
                                filters.push('اورژانسی');
                                break;
                            case 3:
                                filters.push('خون شسته');
                                break;
                            case 4:
                                filters.push('اشعه دیده');
                                break;
                            case 5:
                                filters.push('اورژانسی از سازمان');
                                break;
                            default:
                        }

                        return filters;
                    }
                }, {
                    headerName: 'عملیات',
                    headerTooltip: 'عملیات',
                    pinned: this.props.gridDefaultSettings.pinOperationColumn,
                    sortable: false,
                    filter: false,
                    minWidth: 150,
                    enableRowGroup: false,
                    cellRenderer: 'control'
                }];
                break;
            case 'ORG':
                grid.columnDefs = [{
                    field: 'hospitalFullName',
                    headerName: 'نام بیمارستان',
                    headerTooltip: 'نام بیمارستان',
                    checkboxSelection: true,
                    headerCheckboxSelection: true,
                    filter: 'agTextColumnFilter'
                }, {
                    field: 'hospitalShortName',
                    headerName: 'نام کوتاه بیمارستان',
                    headerTooltip: 'نام کوتاه بیمارستان',
                    hide: true
                }, {
                    field: 'totalProductCount',
                    headerName: 'تعداد کل فرآورده‌ها',
                    headerTooltip: 'تعداد کل فرآورده‌ها'
                }, {
                    field: 'state',
                    headerName: 'وضعیت',
                    headerTooltip: 'وضعیت',
                    pinned: this.props.gridDefaultSettings.pinStatusColumn,
                    sortable: false,
                    enableRowGroup: false,
                    cellRenderer: 'state',
                    valueGetter: row => {
                        const filters = [row.data.statusStr];

                        switch (row.data.formTypeId) {
                            case 1:
                                filters.push('عادی');
                                break;
                            case 2:
                                filters.push('اورژانسی');
                                break;
                            case 3:
                                filters.push('خون شسته');
                                break;
                            case 4:
                                filters.push('اشعه دیده');
                                break;
                            case 5:
                                filters.push('اورژانسی از سازمان');
                                break;
                            default:
                        }

                        return filters;
                    }
                }, {
                    headerName: 'عملیات',
                    headerTooltip: 'عملیات',
                    pinned: this.props.gridDefaultSettings.pinOperationColumn,
                    sortable: false,
                    filter: false,
                    minWidth: 150,
                    enableRowGroup: false,
                    cellRenderer: 'control'
                }];
                break;
            default:
        }

        this.setState({updated: false, action, grid});
    }

    reject(row, props = {loading: _ => null}) {
        this.ref.prompt.current.open({
            title: 'اخطار',
            description: 'آیا می خواهید درخواست را حذف می کنید؟',
            buttons: PromptControl.OK_CANCEL,
            onClose: button => {
                if (button.id === PromptControl.OK) {
                    props.loading();

                    if (this.checkWorkArea() === 'HOSPITAL') {
                        Hospital.rejectRequest({
                            sectionRequestId: row?.sectionRequestId
                        }).then(_ => {
                            this.setState({updated: true});

                            this.updateGrid(true);

                            new Notif(Resource.STRING.FETCH.DELETE_SUCCESSFUL).show();
                            props.loading(false);
                        }).catch(message => {
                            new Notif({message, theme: 'error'}).show();

                            props.loading(false);
                        });
                    } else if (this.checkWorkArea() === 'ORG') {
                        Org.rejectRequest({
                            hospitalRequestId: row?.hospitalRequestId
                        }).then(_ => {
                            this.setState({updated: true});

                            this.updateGrid(true);

                            new Notif(Resource.STRING.FETCH.DELETE_SUCCESSFUL).show();
                            props.loading(false);
                        }).catch(message => {
                            new Notif({message, theme: 'error'}).show();

                            props.loading(false);
                        });
                    }
                }
            }
        });
    };

    view(row) {
        switch (row.formTypeId) {
            case 1: // NORM
                if (this.checkWorkArea() === 'HOSPITAL')
                    this.ref.modalNormRequest.current.open({sectionRequestId: row.sectionRequestId}, ModalAction.VIEW);
                else if (this.checkWorkArea() === 'ORG')
                    this.ref.modalOrgNormRequest.current.open({hospitalRequestId: row.hospitalRequestId}, ModalAction.VIEW);
                break;
            case 2: // EMER
                if (this.checkWorkArea() === 'HOSPITAL')
                    this.ref.modalEmerRequest.current.open({sectionRequestId: row.sectionRequestId}, ModalAction.VIEW);
                else if (this.checkWorkArea() === 'ORG')
                    this.ref.modalOrgEmerRequest.current.open({hospitalRequestId: row.hospitalRequestId}, ModalAction.VIEW);
                break;
            case 3: // WASH
                if (this.checkWorkArea() === 'HOSPITAL')
                    this.ref.modalWashRequest.current.open({sectionRequestId: row.sectionRequestId}, ModalAction.VIEW);
                else if (this.checkWorkArea() === 'ORG')
                    // new Notif({message: 'امکان مشاهده درخواست وجود ندارد.', theme: 'error'}).show();
                    this.ref.modalWashRequest.current.open({hospitalRequestId: row.hospitalRequestId}, ModalAction.VIEW);
                break;
            case 4: // IRRADIATE
                if (this.checkWorkArea() == 'HOSPITAL')
                    this.ref.modalIrradiateRequest.current.open({sectionRequestId: row.sectionRequestId}, ModalAction.VIEW);
                else
                    this.ref.modalIrradiateRequest.current.open({hospitalRequestId: row.hospitalRequestId}, ModalAction.VIEW);
                break;
            case 5: // ORG_EMER
                this.ref.modalOrgEmerRequest.current.open({sectionRequestId: row.sectionRequestId}, ModalAction.VIEW);
                break;
            default:
                break;
        }
    };
}

const mapStateToProps = state => {
    return {
        gridDefaultSettings: state.grid.defaultSettings
    };
};

export default connect(mapStateToProps)(ModalAwaitingRequests);